import { z } from "zod";

// Schema for form data
export const registerFormSchema = z
  .object({
    firstName: z
      .string()
      .min(1, "First name is required.")
      .min(2, "First name must have at least 2 characters.")
      .max(20, "First name must have at most 20 characters.")
      .regex(
        new RegExp(/^[a-zA-Z\u00C0-\u017F-]+$/),
        "First name must contains only letters and hyphen."
      )
      .regex(
        new RegExp(/^(?!-).*(?<!-)$/),
        "First name cannot begin or end with a hyphen."
      ),
    lastName: z
      .string()
      .min(1, "Last name is required.")
      .min(2, "Last name must have at least 2 characters.")
      .max(20, "Last name must have at most 20 characters.")
      .regex(
        new RegExp(/^[a-zA-Z\u00C0-\u017F-]+$/),
        "Last name must contains only letters and hyphen."
      )
      .regex(
        new RegExp(/^(?!-).*(?<!-)$/),
        "Last name cannot begin or end with a hyphen."
      ),
    email: z
      .string()
      .min(1, "Email is required.")
      .email("Email must be valid."),
    phoneNumber: z
      .string()
      .min(1, "Phone number is required.")
      .length(10, "Phone number must have 10 numbers.")
      .regex(
        new RegExp(/^[0-9]+$/),
        "Phone number must contains only numbers."
      ),
    country: z.string({ required_error: "Country is required." }),
    state: z.string().optional(),
    agentLicenseNumber: z
      .string()
      .max(20, "License number must have at most 20 characters.")
      .optional(),
    password: z
      .string()
      .min(1, "Password is required.")
      .min(6, "Password must have at least 6 characters.")
      .regex(
        new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).*$/),
        "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number and a special character."
      ),
    confirmPassword: z.string().min(1, "Password confirmation is required."),
    agreement: z.boolean().refine((value) => value === true, {
      message: "You must accept the terms and conditions.",
    }),
    apiReferralCode: z.string().optional(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Password confirmation does not match.",
    path: ["confirmPassword"],
  })
  .refine(
    (data) => {
      if (data.country === "US" && !data.state) {
        return false;
      }
      return true;
    },
    {
      message: "State is required.",
      path: ["state"],
    }
  )
  .refine(
    (data) => {
      if (data.country === "US" && !data.agentLicenseNumber) {
        return false;
      }
      return true;
    },
    {
      message: "License number is required.",
      path: ["agentLicenseNumber"],
    }
  );
